export const STATE_LABEL = {
  pending: 'Pendiente',
  accepted: 'Aceptado',
  preparing: 'Preparando',
  served: 'Servido',
  paid: 'Pagado',
  cancelled: 'Cancelado'
};

export const STATE_TONE = {
  pending: 'pink',
  accepted: 'gold',
  preparing: 'cyan',
  served: 'green',
  paid: 'faint',
  cancelled: 'red'
};

export const BARRA_CATS = new Set([
  'cocktails', 'copas', 'cervezas', 'vinos', 'sin_alcohol',
  'refrescos', 'cervezas_botella', 'cervezas_grifo', 'zumos'
]);

export function prepStationOf(item) {
  const explicit = item?.prepStation || item?.productId?.prepStation;
  if (explicit === 'barra' || explicit === 'cocina') return explicit;
  const category = item?.category || item?.productId?.category || '';
  return BARRA_CATS.has(category) ? 'barra' : 'cocina';
}

export function tagFor(category) {
  return BARRA_CATS.has(category) ? 'BARRA' : 'COCINA';
}

export function urgencyTier(minutes) {
  if (minutes >= 25) return 'critical';
  if (minutes >= 15) return 'warning';
  return 'ok';
}

export function nextActions(status) {
  if (status === 'pending') return [{ status: 'accepted', label: 'Aceptar' }, { status: 'preparing', label: 'Preparar' }];
  if (status === 'accepted') return [{ status: 'preparing', label: 'Preparar' }];
  if (status === 'preparing') return [{ status: 'served', label: 'Listo' }];
  if (status === 'served') return [];
  return [];
}

export function isLiveOrder(order) {
  if (!order || order.status === 'cancelled') return false;
  return (order.items || []).some((item) => {
    const status = item.status || order.status;
    return !['served', 'paid', 'cancelled'].includes(status);
  });
}
